module.exports = __webpack_public_path__ + "static/media/health_question.010f446e.mp3";